// OrderFilterPage.js
import { useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";


import {
  setStatusFilter,
  setSearchFilter,
  clearSearchFilter,
  selectOrderState,
} from "../../../store/orderFilterSlice";
import { CustomDropdown } from "../../../component/customdropdown/CustomDropdown";
import { SearchInput } from "../../../component/shared/formElements/searchInput/SearchInput";
import { useGetOrdersListQuery } from "../../../services/order/orderApiSlice";
import classes from "./orderFilterPage.module.css";

const approvalStatusArray = [
  { id: "", label: "Select Approval Status" },
  { id: "0", label: "Pending" },
  { id: "1", label: "Approved" },
  { id: "2", label: "Rejected" },
];

export const OrderFilterPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { status, search } = useSelector(selectOrderState);

  // 🔹 Sync URL → Redux on mount only
  useEffect(() => {
    const statusParam = searchParams.get("status") ?? "";
    const searchParam = searchParams.get("search") ?? "";

    dispatch(setStatusFilter(statusParam));
    dispatch(setSearchFilter(searchParam));
  }, [searchParams, dispatch]);

  // 🔹 Update URL and Redux
  const updateURLAndStore = useCallback(
    (key, value) => {
      const newParams = new URLSearchParams(searchParams);
      if (value) newParams.set(key, value);
      else newParams.delete(key);

      setSearchParams(newParams);

      if (key === "status") dispatch(setStatusFilter(value));
      if (key === "search")
        dispatch(value ? setSearchFilter(value) : clearSearchFilter());
    },
    [dispatch, searchParams, setSearchParams]
  );

  // 🔹 Debounced search
 

  // 🔹 Fire API automatically whenever filters change
  useGetOrdersListQuery({ status, search });

  return (
    <div className={classes.box}>
       <div className={classes.box__content}>
              <h1 className={classes.box__content__title}>Orders</h1>
            </div>
      <div className={classes.box__content}>
        <SearchInput
          placeholder="Search by Order Id or Transaction Id"
          value={search}
         
          onSearch={(text) => updateURLAndStore("search", text)}
          onClear={() => updateURLAndStore("search", "")}
        />
      </div>

      <div className={classes.box__content}>
        <CustomDropdown
          id="status"
          label="Select Approval Status"
          options={approvalStatusArray}
          selectedId={status ?? ""} // <-- FIX
          onSelection={(_, value) => updateURLAndStore("status", value)}
        />
      </div>
    </div>
  );
};
